'use strict';

var _ = require('lodash');
function DirectForecastingConfigurationService(configurationService, featureToggleService) {
  function isDirectForecastEnabled(selectedRow) {
    if (featureToggleService.isEnabled('DIRECT_FORECAST_ENABLE')) {
      var market = getMarketFromRow(selectedRow);
      if (!market) {
        return false;
      }
      return isDirectForecastingMarket(market.origin, market.destination);
    }
    return false;
  }
  function isDirectForecastingMarket(origin, destination) {
    var selectedMarket = _.find(configurationService.getMarkets(), {
      origin: origin,
      destination: destination
    });
    return _.get(selectedMarket, 'forecastType', 'Market') === 'Service';
  }
  function getMarketFromRow(row) {
    if (!row) {
      return;
    }
    if (row.origin && row.destination) {
      return {
        origin: row.origin,
        destination: row.destination
      };
    } else if (row.marketOrigin && row.marketDestination) {
      return {
        origin: row.marketOrigin,
        destination: row.marketDestination
      };
    } else if (row.market) {
      var splitMarket = row.market.split('-');
      return {
        origin: splitMarket[0],
        destination: splitMarket[1]
      };
    }
  }
  return {
    isDirectForecastEnabled: isDirectForecastEnabled,
    isDirectForecastingMarket: isDirectForecastingMarket
  };
}
DirectForecastingConfigurationService.$inject = ['ConfigurationService', 'FeatureToggleService'];
module.exports = DirectForecastingConfigurationService;